// extracted by mini-css-extract-plugin
export default {"text":"BusinessElementDependency_text__XqX75"};